module.exports = __webpack_public_path__ + "img/magnifying-glass-plus.cf68019.svg";